import _ from 'lodash'

const settingsError = (state) => _.get(state, 'errors')
const isLoading = (state) => _.get(state, 'loading')
const settings = (state) => _.get(state, 'settings')
const login = (state) => _.get(state, 'login')
const chaptersList = (state) => _.get(state, 'chapters')
const appCore = (state) => _.get(state, 'app_core')
const baseCore = (state) => _.get(state, 'core')
const ci_cd = (state) => _.get(state, 'ci_cd')
const styles = (state) => _.get(state, 'styles')
const user = (state) => _.get(state, 'user')
const web = (state) => _.get(state, 'web')
const eventSettings = (state) => _.get(state, 'event')
const backUser = (state) => _.get(state, 'back_user')
const url = (state) => _.get(state, 'url')
const registration_fields = (state) => _.get(state, 'registration_fields')
const fields_loading = (state) => _.get(state, 'fields_loading')

export default {
	settingsError,
	isLoading,
	settings,
	login,
	ci_cd,
	styles,
	chaptersList,
	appCore,
	baseCore,
	web,
	user,
	backUser,
	eventSettings,
	url,
	registration_fields,
	fields_loading,
}
